import produce from 'immer'
import { combineReducers } from 'redux'
import { TOKEN } from '../libs/permissions'
import {
  AUTH_SUCCESS,
  AUTH_ERROR,
  FETCH_CONTACT,
  SAVE_CONTACT,
  SET_CONTACT,
  FETCH_CONTACTS,
  SET_CONTACTS,
  FETCH_EXCLUSIONS,
  SAVE_EXCLUSIONS,
  SET_EXCLUSIONS,
  FETCH_EMAIL_PREFERENCES,
  SAVE_EMAIL_PREFERENCES,
  SET_EMAIL_PREFERENCES,
  FETCH_DATABASE_PREFERENCES,
  SAVE_DATABASE_PREFERENCES,
  SET_DATABASE_PREFERENCES,
  SET_ERROR,
  FETCH_FILTER_RESULTS,
  SET_FILTER_RESULTS,
  DISMISS_FIRST_TIME_HELP
} from './actions'

const DEFAULT_USER_STATE = {
  token: window.sessionStorage[TOKEN],
  accountId: '',
  authorized: false,
  authorizing: true,
  error: null,
  contact: null,
  contacts: [],
  exclusions: null,
  emailPreferences: null,
  databasePreferences: null,
  emailAddress: '',
  userName: '',
  isAdmin: false,
  claims: []
}

const DEFAULT_LOADING_STATE = {
  loadingFilterResults: [],
  loading: false,
  contactLoading: false,
  contactsLoading: false,
  exclusionsLoading: false,
  emailPreferencesLoading: false,
  databasePreferencesLoading: false
}

const loadingReducer = produce((draft, action) => {
  switch (action.type) {
    case AUTH_SUCCESS:
      draft.loading = false
      break
    case AUTH_ERROR:
      draft.loading = false
      break
    case FETCH_CONTACT:
      draft.contactLoading = true
      break
    case FETCH_CONTACTS:
      draft.contactsLoading = true
      break
    case FETCH_EXCLUSIONS:
      draft.exclusionsLoading = true
      break
    case FETCH_EMAIL_PREFERENCES:
      draft.emailPreferencesLoading = true
      break
    case FETCH_DATABASE_PREFERENCES:
      draft.databasePreferencesLoading = true
      break
    case SAVE_CONTACT:
      draft.contactLoading = true
      break
    case SAVE_EXCLUSIONS:
      draft.exclusionsLoading = true
      break
    case SAVE_EMAIL_PREFERENCES:
      draft.emailPreferencesLoading = true
      break
    case SAVE_DATABASE_PREFERENCES:
      draft.databasePreferencesLoading = true
      break
    case SET_CONTACT:
      draft.contactLoading = false
      break
    case SET_CONTACTS:
      draft.contactsLoading = false
      break
    case SET_EXCLUSIONS:
      draft.exclusionsLoading = false
      break
    case SET_EMAIL_PREFERENCES:
      draft.emailPreferencesLoading = false
      break
    case SET_DATABASE_PREFERENCES:
      draft.databasePreferencesLoading = false
      break
    case SET_ERROR:
      draft.loading = false
      draft[`${action.payload.errorType}Loading`] = false
      break
    case FETCH_FILTER_RESULTS:
      draft.loadingFilterResults.push(action.payload.filterIndex)
      break
    case SET_FILTER_RESULTS:
      var i = draft.loadingFilterResults.indexOf(action.payload.filterIndex)
      if (i >= 0) draft.loadingFilterResults.splice(i, 1)
      break
    default:
      break
  }
}, DEFAULT_LOADING_STATE)

const userReducer = produce((draft, action) => {
  switch (action.type) {
    case AUTH_SUCCESS:
      draft.authorized = true
      draft.authorizing = false
      draft.error = null

      draft.token = action.payload.token
      draft.accountId = action.payload.accountId
      draft.emailAddress = action.payload.emailAddress
      draft.userName = action.payload.userName
      draft.isAdmin = action.payload.isAdmin
      draft.claims = action.payload.claims
      break
    case AUTH_ERROR:
      draft.authorized = false
      draft.authorizing = false
      draft.error = action.payload

      draft.token = null
      draft.accountId = ''
      draft.emailAddress = ''
      draft.userName = ''
      draft.isAdmin = false
      draft.claims = []
      break
    case SET_CONTACT:
      draft.contact = action.payload
      break
    case SET_CONTACTS:
      draft.contacts = action.payload
      break
    case SET_EXCLUSIONS:
      draft.exclusions = action.payload
      break
    case SET_EMAIL_PREFERENCES:
      draft.emailPreferences = action.payload
      break
    case SET_DATABASE_PREFERENCES:
      draft.databasePreferences = action.payload
      break
    case SET_ERROR:
      draft.error = action.payload
      break
    case SET_FILTER_RESULTS:
      draft.emailPreferences.filterResults.filters.splice(action.payload.filterIndex, 0, action.payload.result)
      break
    case DISMISS_FIRST_TIME_HELP:
      draft.databasePreferences.interstitial.shouldShow = false
      break
    default:
      break
  }
}, DEFAULT_USER_STATE)

const rootReducer = combineReducers({
  user: userReducer,
  loading: loadingReducer
})

export default rootReducer
